import React, {useState} from 'react';
import FormField from '../FormField/FormField';
import SubmitButton from '../SubmitButton/SubmitButton';

import './CreateDepartment.css';
import {createDepartment} from '../../api/departmentApi';

const CreateDepartment = ({
  handleClose,
  isDepartmentFormOpen,
  selectedItemId,
  parentDepartmentId = null,
  updateDepartmentData,
}) => {
  const [formData, setFormData] = useState({
    name: '',
    errors: {},
  });

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      errors: {...prev.errors, [name]: ''},
    }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = 'Название отдела обязательно';
    }

    setFormData((prev) => ({...prev, errors}));
    return Object.keys(errors).length === 0;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const {errors, ...dataToSend} = formData;
      createDepartment({
        ...dataToSend,
        organisation_id: selectedItemId,
        parent_department_id: parentDepartmentId,
      }).then((res) => {
        updateDepartmentData();
      });
      setFormData({
        name: '',
        workplaces: [],
        errors: {},
      });
      handleClose();
    }
  };

  return (
    <>
      <div
        className={`overlay ${isDepartmentFormOpen ? 'show' : 'hide'}`}
        onClick={handleClose}
      ></div>

      <section
        className={`create-department ${
          isDepartmentFormOpen ? 'show' : 'hide'
        }`}
      >
        <div className='create-department__form'>
          <div className='create-department__header'>
            <h2 className='create-department__header-title'>Создать отдел</h2>
            <SubmitButton
              className='create-department__save-button'
              text='Сохранить'
              type='submit'
              onClick={handleFormSubmit}
            />
            <button onClick={handleClose} className='profile__close-btn' />
          </div>
          <form
            onSubmit={handleFormSubmit}
            className='create-department__form-container'
          >
            <FormField
              label='Название отдела'
              name='name'
              value={formData.name}
              onChange={handleChange}
              error={formData.errors.name}
              required
              type='text'
            />
          </form>
        </div>
      </section>
    </>
  );
};

export default CreateDepartment;
